var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gallery", class: [_vm.bemFacet] }, [
    _c(
      "div",
      { staticClass: "gallery--break-out", style: _vm.breakOutStyles },
      [
        _c("div", { staticClass: "gallery--wrap" }, [
          _c("div", { staticClass: "gallery--rail grid grid__gallery" }, [
            _c("div", { staticClass: "gallery--container" }, [
              _c(
                "ul",
                {
                  staticClass: "u-reset gallery--items",
                  class: [_vm.isFluid ? "" : "grid--row"]
                },
                _vm._l(_vm.plugins, function(plugin, pluginIdx) {
                  return _c(
                    "li",
                    {
                      key: pluginIdx,
                      staticClass: "gallery--item",
                      class: [_vm.isFluid ? "" : "grid--col"]
                    },
                    [
                      _c(plugin.type, {
                        tag: "component",
                        attrs: {
                          plugin: plugin,
                          "position-id": _vm.positionId(pluginIdx)
                        }
                      })
                    ],
                    1
                  )
                })
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22317372", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22317372","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/gallery/index.vue
// module id = 302
// module chunks = 5